/**
 * Joins the string with the given separator, but after removing all nulls.
 * @param strings
 * @param separator
 */
import { not } from 'src/js/helper/predicate/global.predicate';
import { isNilOrEmpty } from 'src/js/util/global-util';

export const joinNonNull = (strings: string[], separator = ' '): string => {
  return strings.filter(not(isNilOrEmpty)).join(separator);
};

export const wrapString = (string: string, leftString: string, rightString: string): string => {
  return leftString + string + rightString;
};

/**
 * Formats a number or numeric string with commas every 3 digits.
 * Examples:
 *   1234567 => "1,234,567"
 *   "1234567.89" => "1,234,567.89"
 *   -1234567 => "-1,234,567"
 */
export function numberWithCommas(value: number | string): string {
  if (typeof value === 'number') {
    return value.toLocaleString();
  }
  if (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value)) {
    const [intPart, decPart] = value.split('.');
    const sign = intPart.startsWith('-') ? '-' : '';
    const absInt = sign ? intPart.slice(1) : intPart;
    const withCommas = absInt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sign + withCommas + (decPart ? '.' + decPart : '');
  }
  return value;
}
